module.exports = __webpack_public_path__ + "img/calendarCheck.18d3a23b.svg";